<template>
  <nav class="navbar">
    <div class="navbar-container">
      <div class="logo">
        <img src="/icon_logo.png" alt="AUTOGRI Logo Icon" class="logo-icon" />
        <span class="logo-text">AUTOGRI ELD</span>
      </div>
      <button class="mobile-menu-btn" @click="toggleMenu" :class="{ 'active': isMenuOpen }">
        <span></span>
        <span></span>
        <span></span>
      </button>
      <div class="nav-right" :class="{ 'active': isMenuOpen }">
        <ul class="nav-menu">
          <li><a href="#services" @click="closeMenu">{{ $t('nav.services') }}</a></li>
          <li><a href="#contact" @click="closeMenu">{{ $t('nav.contact') }}</a></li>
        </ul>
        <div class="language-switcher">
          <select v-model="currentLocale" @change="changeLanguage(currentLocale)">
            <option value="en">ENG</option>
            <option value="ru">RU</option>
            <option value="uk">UA</option>
          </select>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()
const currentLocale = computed({
  get: () => locale.value,
  set: (value) => locale.value = value
})

const isMenuOpen = ref(false)

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
}

const closeMenu = () => {
  isMenuOpen.value = false
}

const changeLanguage = (lang) => {
  locale.value = lang
}
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  padding: 1rem 0;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.navbar-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.logo-icon {
  width: 38px;
  height: 38px;
  object-fit: contain;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.10);
}

.logo-text {
  color: #ffffff;
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  white-space: nowrap;
}

.nav-menu {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 2rem;
}

.nav-menu a {
  color: #e0e0e0;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s ease;
}

.nav-menu a:hover {
  color: #ffffff;
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.language-switcher {
  margin-left: 1rem;
  position: relative;
}

.language-switcher select {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #ffffff;
  padding: 0.4rem 0.8rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 0.5rem center;
  background-size: 1.2em;
  padding-right: 2.5rem;
  min-width: 80px;
}

.language-switcher select:hover {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
}

.language-switcher select:focus {
  outline: none;
  border-color: rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.1);
}

.language-switcher select option {
  background: #1a1a1a;
  color: #ffffff;
  padding: 0.5rem;
}

.mobile-menu-btn {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 21px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1001;
}

.mobile-menu-btn span {
  width: 100%;
  height: 3px;
  background-color: #ffffff;
  border-radius: 3px;
  transition: all 0.3s ease;
}

.mobile-menu-btn.active span:nth-child(1) {
  transform: translateY(9px) rotate(45deg);
}

.mobile-menu-btn.active span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-btn.active span:nth-child(3) {
  transform: translateY(-9px) rotate(-45deg);
}

@media (max-width: 768px) {
  .mobile-menu-btn {
    display: flex;
  }

  .nav-right {
    position: fixed;
    top: 0;
    right: -100%;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.95);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    flex-direction: column;
    justify-content: center;
    gap: 2rem;
    transition: right 0.3s ease;
    padding: 2rem;
  }

  .nav-right.active {
    right: 0;
  }

  .nav-menu {
    flex-direction: column;
    align-items: center;
    gap: 2rem;
  }

  .nav-menu a {
    font-size: 1.2rem;
  }

  .language-switcher {
    margin: 1rem 0;
    width: 100%;
    max-width: 200px;
  }

  .language-switcher select {
    width: 100%;
    padding: 0.75rem 1rem;
    font-size: 1rem;
    background-position: right 1rem center;
    background-size: 1.5em;
    padding-right: 3rem;
    border-radius: 8px;
    border-width: 2px;
  }

  .language-switcher select option {
    padding: 1rem;
    font-size: 1rem;
  }
}
</style> 